import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 20px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		background-color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	`,

	CompactWrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 8px 12px;
		border: 1px solid #e0e0e0;
		border-radius: 6px;
		background-color: #fff;
	`,

	TimerSection: styled.div`
		text-align: center;
	`,

	MainTimer: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	`,

	LevelTitle: styled.h2`
		font-size: 24px;
		font-weight: bold;
		margin: 0;
		color: #333;
	`,

	LevelInfo: styled.span`
		font-size: 14px;
		font-weight: 500;
		color: #666;
	`,

	CountdownDisplay: styled.h1`
		font-size: ${(props) => (props.compact ? '18px' : '48px')};
		font-weight: bold;
		margin: 0;
		font-family: 'Courier New', monospace;
		color: ${(props) => (props.$warning ? '#ff4444' : '#333')};
		background-color: ${(props) =>
			props.$warning ? '#fff0f0' : 'transparent'};
		padding: ${(props) => (props.compact ? '4px 8px' : '8px 16px')};
		border-radius: 4px;
		transition: all 0.3s ease;
	`,

	BlindsInfo: styled.h3`
		font-size: 16px;
		font-weight: 600;
		margin: 0;
		color: #555;
	`,

	NextInfo: styled.h4`
		font-size: 14px;
		font-weight: 500;
		margin: 0;
		color: #666;
	`,

	InfoSection: styled.div`
		display: flex;
		justify-content: space-around;
		gap: 16px;
		padding: 16px 0;
		border-top: 1px solid #e0e0e0;
		border-bottom: 1px solid #e0e0e0;

		@media (max-width: 768px) {
			flex-direction: column;
			gap: 8px;
		}
	`,

	InfoItem: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
	`,

	InfoLabel: styled.span`
		font-size: 12px;
		font-weight: 500;
		color: #888;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	`,

	InfoValue: styled.span`
		font-size: 16px;
		font-weight: 600;
		font-family: 'Courier New', monospace;
		color: #333;
	`,

	GameState: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 16px;
		flex-wrap: wrap;
	`,

	PauseIndicator: styled.div`
		background-color: #ff9800;
		color: white;
		padding: 6px 12px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	`,

	StateInfo: styled.div`
		font-size: 14px;
		color: #666;
		font-weight: 500;
	`,
}

export default Style
